<div class="groupSelection">
  <abc-button
    class="objectsSetsButton"
    [icon]="this.res.svgUrl('Objects-Set')"
    [toolTipContent]="this.res.get('Object-Sets')"
    (onClick)="showObjectsSets()"
    [visible]="isObjectSetVisible"
  ></abc-button>
  <abc-tab-panel
    #groupSelectionTabPanel
    class="group-selection-tab-panel"
    [width]="'100%'"
    [height]="'100%'"
    [animationEnabled]="true"
    [swipeEnabled]="true"
    [dataSource]="groups"
  >
    <div *dxTemplate="let group of 'title'">
      <span>{{ getSafeGroupDesignation(group) | async }}</span>
    </div>
    <div *dxTemplate="let group of 'item'" class="tabpanel-item">
      <div class="fullPageContainer">
        <abc-object-selection
          #ObjectSelection
          class="object-selection"
          [group]="group"
          (newItemEvent)="countItems($event)"
          (selectedItemsCount)="onItemsCountChange($event)"
        ></abc-object-selection>
      </div>
      <!-- <div fxFlex="nogrow"> Toolbar </div> -->
    </div>
  </abc-tab-panel>
</div>
<div #objectsSets></div>
